import React, { Component } from 'react';
import { observer } from 'mobx-react';

import UsedLinksDashboardStore from 'js/stores/pages/AdminDashboardPage/UsedLinksDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import Controls from '../../DashPanel/Controls';

import NotFound from './NotFound';
import ListItem from "js/components/pages/AdminDashboardPage/List/ListItem";
import LinkUsageSummary from "js/components/pages/AdminDashboardPage/Items/Item/LinkUsageSummary";
import ListMessage from "js/components/pages/AdminDashboardPage/List/ListMessage";
import Row from "js/components/pages/AdminDashboardPage/List/Row";

@observer
export default class Dashboard extends Component {
  usedLinksDashboard = UsedLinksDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.usedLinksDashboard.load();
  }

  componentDidUpdate() {
    this.usedLinksDashboard.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.usedLinksDashboard.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Used links</Title>
          <Controls>
            <Pagination model={this.usedLinksDashboard} />
          </Controls>
        </Header>

        <Content>
          {this.usedLinksDashboard.isLoading ? (
            <LoadingSpinner />
          ) : this.usedLinksDashboard.used_links.length ? (
            <div>
              <Row>
                <div>
                  <ListItem to={null}>
                    <LinkUsageSummary log={{
                      'latest_created_at': 'Latest Date',
                      'alias': 'Alias',
                      'mode': 'Mode',
                      'latest_ip_address': 'Latest IP',
                      'total_ips': 'Total',
                      'total_diff_ips': 'Unique'
                    }} />
                  </ListItem>
                </div>
              </Row>
              <Row>
                  <div>
                    {this.usedLinksDashboard.used_links ? (
                      this.usedLinksDashboard.used_links.map(log => (
                        <ListItem key={log.item_id} to={log.mode === 'token' ? `/admin/tokens/token/${log.alias}` : `/admin/items/item/${log.alias}`}>
                          <LinkUsageSummary log={log} />
                        </ListItem>
                      ))
                    ) : (
                      <ListMessage>Not used so far</ListMessage>
                    )}
                  </div>
              </Row>
            </div>
          ) : (
            <NotFound>No used links found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
